<script lang="tsx">


import {defineComponent, ref, SetupContext} from 'vue';
import Hero from "@/components/common/typography/Hero.vue";
import Caption from "@/components/common/typography/Caption.vue";
import Icon from "@/components/common/icons/Icon.vue";

export interface NotificationData {
  title: string,
  text?: string
}

export default defineComponent({
  name: 'Notification',
  components: {Caption, Hero, Icon},
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
    }
  },
  setup(props, context) {
    const isClosed = ref(false);
    return () =>
      <div class={[
        "notification",
        isClosed.value ? "notification--closed" : "",
      ]}>
        <Icon class="notification-check" name="Check"/>
        <div class="notification-content">
          <Hero class="notification-content-title" type="Hero6" withFocusLine={false}>{props.title}</Hero>
          {props.text &&
          <Caption class="notification-content-text">{props.text}</Caption>
          }
        </div>
        <Icon class="notification-close" name="Close" onClick={() => {
          isClosed.value = true
        }}/>

      </div>
  }
});

</script>


<style lang="scss" scoped>
@import "src/css/common/index";

@include important {
  .notification {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    width: 100%;

    color: $color-surface;

    background: $color-action-1;
    backdrop-filter: blur(4px);
    border-radius: 4px;
    padding: $spacing-2;

    > * + * {
      margin-left: $spacing-2;
    }

    &-check {
      font-size: 24px;
      flex: 0 0 auto;
    }

    &-close {
      font-size: 24px;
      cursor: pointer;
      flex: 0 0 auto;

      &:hover {

      }
    }

    &--closed {
      display: none;
    }

    &-content {
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;

      &-text {
        margin-top: $spacing-1;
      }
    }
  }
}
</style>
